import { useEffect, useRef, useState } from 'react';

import type { PromopanelResponse } from '../../types/entities';

import PromopanelComponent from '@helsenorge/core-cms/promopanel';
import type { PromoBlock } from '@helsenorge/core-cms/types/entities';
import { get } from '@helsenorge/framework-utils/cms-content-api-service';
import { useSetLanguageEvent } from '@helsenorge/framework-utils/hn-language';
import { CmsBlocksEvents, WebComponents } from '@helsenorge/framework-utils/web-component/constants';
import { HNeventIsMicroFrontendMounted } from '@helsenorge/framework-utils/web-component/events';
import type { WebCompProps } from '@helsenorge/framework-utils/web-component/register';
import useWebComponentEvents from '@helsenorge/framework-utils/web-component/useWebComponentEvents';

export interface PromopanelProps extends WebCompProps {
  externalid?: string;
}

const Promopanel: React.FC<PromopanelProps> = ({ externalid }) => {
  const [blocks, setBlocks] = useState<Array<PromoBlock>>([]);
  const [hide, setHide] = useState(true);
  const ref = useRef<HTMLDivElement>(null);
  const { subscribe } = useWebComponentEvents<HTMLDivElement>(WebComponents.Promopanel, ref);

  const getPromopanel = (): void => {
    get<PromopanelResponse>(externalid ? `promopanel/${externalid}` : 'promopanel')
      .then(response => {
        if (response?.blocks) {
          setBlocks(response.blocks);
        }
      })
      .catch(() => {
        // Dersom det skjer en feil, logges dette av cms-content-api-service
      });
  };

  useEffect(() => {
    HNeventIsMicroFrontendMounted(WebComponents.Promopanel);

    getPromopanel();

    return subscribe(CmsBlocksEvents.setHiddenPromopanel, (event: CustomEvent) => {
      const hiddenPromopanel = event.detail.hiddenPromopanel;
      setHide(hiddenPromopanel);
    });
  }, []);

  useSetLanguageEvent(() => getPromopanel());

  return <div ref={ref}>{!hide && !!blocks && blocks.length > 0 ? <PromopanelComponent promoblocks={blocks} /> : null}</div>;
};

export default Promopanel;
